
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getCongifInfo } from "@/api/api-operation-service";
import { optionKey, getOptionList } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiCashTemplateTr1 extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private tableData!: objAny;
  @Prop({ default: true }) private isInput!: boolean;

  private invoiceType = "0";
  private configData: objAny = {};
  private invoiceTypeObj: objAny = {
    "0": i18n.t("withdrawalTemplate.no")
  };
  private invoiceTypeList: objAny[] = [];
  async getOptionList(): Promise<void> {
    const data = await getOptionList([optionKey.invoiceTypeObj]);
    this.invoiceTypeList = data[optionKey.invoiceTypeObj];
    const invoiceTypeObj: objAny = {};
    this.invoiceTypeList.map((item: objAny) => {
      invoiceTypeObj[item.itemKey] = item.itemValue;
    });
    this.invoiceTypeObj = invoiceTypeObj;
  }
  async getCongifInfo(): Promise<void> {
    const ret = await getCongifInfo({});
    if (ret.status === this.$config.apiStatus) {
      const itemData: objAny = ret.data[0] || {};
      this.configData = itemData;
      this.configData.invoiceType = itemData.invoiceType
        ? itemData.invoiceType + ""
        : "1";
    }
  }

  mounted(): void {
    this.getCongifInfo();
    this.getOptionList();
  }
}
